export default (value) => value?.toLocaleString('en-US', {
  style: 'currency',
  currency: 'HKD',
}) || 'HK$0';
